import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchShareLinks = ({ type, project, doc }) => {
    return AjaxService({
        method: 'get',
        url: 'share',
        params: {
            type,
            project,
            doc,
            limit: 200
        }
    })
    .then(response => response.data.tokens)
    .catch(handleServerError);
}

export const createShareLink = ({ type, project, doc, description, config }: any) => {
    return AjaxService({
        method: 'post',
        url: 'share',
        data: {
            type,
            project,
            doc,
            description,
            config
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchShareLink = shareLinkId => {
    return AjaxService({
        method: 'get',
        url: `share/${shareLinkId}`
    })
    .then(response => validateResponse(response, 'id').data)
}

export const updateShareLink = (shareLinkId, { description, config }: any) => {
    return AjaxService({
        method: 'put',
        url: `share/${shareLinkId}`,
        data: {
            description,
            config
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeShareLink = shareLinkId => {
    return AjaxService({
        method: 'delete',
        url: `share/${shareLinkId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
